module.exports = __webpack_public_path__ + "static/media/LinhaHig.7494f72b.pdf";